module.exports = __webpack_public_path__ + "assets/keypad-sounds/tone-607c9b8fc9d1a6715c8eae7d96b01d97.wav";